module.exports = __webpack_public_path__ + "static/img/logo-1.787ea751.png";